<h4>{{ actionInfoHeading }}</h4>
<jsg-action-parties-view
  [partySummary]="partySummary"
  [displayedColumns]="displayedColumns"
>
</jsg-action-parties-view>
